import { Button } from "@/components/ui/button";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

/**
 * errorElement for every Handbook route. The CRM has no error boundary of its
 * own, so without this a rendering fault on one page would replace the whole
 * app with React Router's default error screen.
 *
 * The Handbook is the app's first code-split route, which adds one new failure:
 * after a deploy, a tab opened before it asks for a chunk that no longer exists.
 * That is not a bug to report — reloading picks up the new build.
 */
export function HandbookRouteError() {
  const error = useRouteError();
  const message =
    error instanceof Error ? error.message : isRouteErrorResponse(error) ? error.statusText : "";
  const staleChunk = /dynamically imported module|Importing a module script failed|Loading chunk/i.test(
    message,
  );

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <h1 className="text-lg font-medium">
        {staleChunk ? "A new version of the CRM is available" : "This Handbook page couldn't be shown"}
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {staleChunk
          ? "Reload to pick it up. Nothing you were doing elsewhere is lost."
          : "Something went wrong while showing this page. Reload to try again, or go back to the Handbook."}
      </p>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
}
